
export function createOpenOnClickDivs(){

    const output = `
    
        <div 
            id="${this.tab_toggle_id}" 
            class=" smetio-content-interactable smetio-tab-content" 
            data-active="${this.isActive}"
        >
            ${this.text}  
            ${this.openOnClick_preloader}
                                
        </div>
    
    `;    
    
    return output;

};
